export default {
    url: '/userinfo',
    data: {
        'name': 'pudding',
        'age': 16
    }
}